import { RootState } from 'store';
import { useSelector } from 'react-redux';

import { DRIVERS_STATE } from '../../constants';

export const useSelectedDriverLocation = () => {
  const selectedDriverLocation = useSelector((state: RootState) => state[DRIVERS_STATE].selectedLocation);
  return selectedDriverLocation;
};